import { TIME_PERIODS, TimePeriodsValue, StructureTimePeriodsValue } from "@/config/date";
import { Button } from "../ui/button";

type PeriodValue = TimePeriodsValue | StructureTimePeriodsValue;

export const TimeRangePanel = ({
	value,
	onChange,
	periods,
}: {
	value?: PeriodValue;
	onChange: (timePeriod: PeriodValue) => void;
	periods?: { label: string; value: PeriodValue }[];
}) => {
	const items = periods || TIME_PERIODS;
	return (
		<div className="inline-flex flex-col p-2 rounded-md gap-2 border-l">
			{items.map(period => (
				<Button
					key={period.value}
					variant={value === period.value ? "default" : "ghost"}
					size="sm"
					onClick={() => onChange(period.value)}
					className="rounded-md"
				>
					{period.label}
				</Button>
			))}
		</div>
	);
};
